// extracted by mini-css-extract-plugin
module.exports = {"container":"layout__container___1n0mR","header":"layout__header___SYsle","body":"layout__body___UaADf"};